import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { formatToShortDateOrNull } from '~/util/date';

const WoundPatientsDataTable = createQueryDataTable('legacy-wound-patient');
type TableProps = PropsOfQueryDataTable<typeof WoundPatientsDataTable>;

const columnDefinitions = WoundPatientsDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true,
		renderCell: row => `${row.patientName} (MR#: ${row.patientCode})`,
		exportColumnName: 'patient',
		width: 'w-[300px]'
	},
	{
		header: 'SOC Date',
		key: 'startOfCare',
		sortable: true,
		width: 'w-[120px]',
		renderCell: row => formatToShortDateOrNull(row.startOfCare, '-')
	},
	{
		header: 'Cert #',
		width: 'w-[120px]',
		key: 'certificationNumber',
		sortable: true
	},
	{
		header: 'Primary Diagnosis',
		key: 'primaryDiagnosis',
		width: 'w-[120px]',
		sortable: true
	},
	{
		header: 'Integumentary Interventions',
		key: 'integumentaryInterventions',
		cellClassName: 'max-w-0 truncate',
		renderCell: row => (row.integumentaryInterventions ? row.integumentaryInterventions.replace('INTEGUMENTARY INTERVENTIONS:', '') : null)
	}
]);

export function WoundPatientsTable(props: TableProps) {
	return (
		<WoundPatientsDataTable.Table
			columns={columnDefinitions}
			emptyMessage="No wound patients found"
			{...props}
			getRowNotes={x => x.integumentaryInterventions}
			exportable
			rowLabel="Interventions: "
		/>
	);
}
